import _ from "lodash";
import React, { useState } from "react";
import classes from "./ModalComponent.scss";
import {
  Button,
  MediaCard,
  RadioButton,
  EmptyState,
  Modal,
} from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { NoSearchResultsIllustration } from "@toddle-edu/ds-theme";
import { SHIFT_ENTER_SUBMIT_SHORTCUT } from "Constants/stringConstants";

const styles = {
  emptySubTextStyle: { whiteSpace: "pre-line" },
};

const MediaCardComponent = ({
  item,
  selectedAttachmentValue,
  onSelectAttachment,
  testId,
}) => {
  const { id, name = "", thumbUrl, url, type, mimeType } = item;

  const isSelected = _.includes(selectedAttachmentValue, id);

  return (
    <MediaCard
      cardType="medium"
      name={name}
      thumbUrl={thumbUrl}
      url={url}
      type={type}
      mimeType={mimeType}
      onClick={() => onSelectAttachment({ value: id })}
      isActivated={isSelected}
      options={
        <RadioButton
          value={id}
          checked={isSelected}
          onChange={e => onSelectAttachment({ value: e.target.value })}
        />
      }
      showMediaPreview={true}
      testId={`${testId}-${id}`}
    />
  );
};

const ModalComponent = props => {
  const {
    updateValue,
    toggleModal,
    attachmentList,
    modalConfig: {
      label = "",
      subText = "",
      modalEmptySubText = "",
      modalEmptyTitle = "",
    },
    testId,
  } = props;

  const { t } = useI18n(["project", "common"]);
  const [selectedAttachmentValue, setSelectedAttachmentValue] = useState([]);

  const onSelectAttachment = ({ value }) => {
    const newSelectedAttachment = value ? [value] : [];
    setSelectedAttachmentValue(newSelectedAttachment);
  };

  const onSelectClick = () => {
    updateValue(selectedAttachmentValue, {
      value: _.filter(attachmentList, item =>
        _.includes(selectedAttachmentValue, _.get(item, "id", ""))
      ),
    });
    toggleModal();
  };

  return (
    <Modal onClose={toggleModal} height="600px" width="480px">
      <Modal.Header
        title={label}
        subtitle={subText}
        hasSeparator={true}
        testId={testId}
      />
      <Modal.Body isScrollable={true}>
        {!_.isEmpty(attachmentList) ? (
          <div className={classes.modalInnerContainer}>
            {_.map(attachmentList, item => {
              return (
                <MediaCardComponent
                  key={_.get(item, "id", "")}
                  item={item}
                  onSelectAttachment={onSelectAttachment}
                  selectedAttachmentValue={selectedAttachmentValue}
                  testId={testId}
                />
              );
            })}
          </div>
        ) : (
          <div className={classes.emptyStateContainer}>
            <EmptyState
              illustration={NoSearchResultsIllustration}
              title={modalEmptyTitle}
              subtitle={modalEmptySubText}
              subtitleStyle={styles.emptySubTextStyle}
              size="small"
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer hasSeparator={true}>
        <div className={classes.footerContainer}>
          <Button
            onClick={toggleModal}
            variant="neutral"
            size="medium"
            type="outlined"
            testId={`${testId}-cancel`}
          >
            {t("common:cancel")}
          </Button>
          <Button
            disabled={_.isEmpty(selectedAttachmentValue)}
            onClick={onSelectClick}
            variant="primary"
            type="fill"
            shortcut={SHIFT_ENTER_SUBMIT_SHORTCUT}
            size="medium"
            testId={`${testId}-select`}
          >
            {t("common:select")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalComponent;
